<template>
  <div class="chat-bubble">
    <button
      type="button"
      class="chat-bubble-btn"
      :class="{ 'chat-bubble-btn--nudge': shouldNudge }"
      :aria-label="t('chat.open_chat')"
      @click="updateShowChat"
    >
      <!--
        Inlined rather than loaded through <img> so the two shapes can be
        coloured separately from SCSS: the bubble body takes the theme brand
        colour, the dots the contrasting foreground.
      -->
      <svg
        class="chat-bubble-icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          class="chat-bubble-icon-body"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z"
        />
        <path
          class="chat-bubble-icon-dots"
          d="M8 12H8.009M11.991 12H12M15.991 12H16"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "../../store/index";

const { t } = useI18n();

const NUDGE_STORAGE_KEY = "chatBubbleNudged";

const shouldNudge = ref(false);

const showChat = computed({
  get: () => store.state.chat.showChat,
});

const updateShowChat = () => {
  store.commit("chat/updateShowChat", !showChat.value);
};

onMounted(() => {
  try {
    if (sessionStorage.getItem(NUDGE_STORAGE_KEY)) return;

    sessionStorage.setItem(NUDGE_STORAGE_KEY, "1");
    shouldNudge.value = true;
  } catch {
    // Storage throws when the browser blocks site data. Skipping the cue is
    // better than replaying it on every page the user opens.
  }
});
</script>
